import { render, staticRenderFns } from "./AdminHolidaysView.vue?vue&type=template&id=80b47db4"
import script from "./AdminHolidaysView.vue?vue&type=script&lang=ts"
export * from "./AdminHolidaysView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports